import { EmployeeSelect, EMPLOYEE_UNASSIGNED } from "@/components/employee-select";
import { useAssignableSalesReps } from "@/features/customers/hooks";

export const SALES_REP_UNASSIGNED = EMPLOYEE_UNASSIGNED;

interface SalesRepSelectProps {
  value: string;
  onChange: (value: string) => void;
}

// SalesRepSelect is the assignment dropdown for the customer sales-rep
// field. Options come from the roster: active Sales-department employees.
export function SalesRepSelect({ value, onChange }: SalesRepSelectProps) {
  const { data: salesReps = [] } = useAssignableSalesReps();
  return (
    <EmployeeSelect
      value={value}
      onChange={onChange}
      options={salesReps}
      emptyHint="No Sales employees in roster"
    />
  );
}
